import 'react-app-polyfill/stable';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
